export const MODAL_GALLERY_FETCH_MODE_URL = "url";
